module.exports = __webpack_public_path__ + "static/media/wbw-logo.289cb2f7.png";